import React, { Fragment } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { AssignContractorsTable } from './assign-contractors-table/AssignContractorsTable'

interface Props {
  isAssignContractorsOpen: boolean
  closeAssignContractors(): void
  refreshLinkedContractors(): void
  selectedMCCustomerId: string
}

export const AssignContractorsModal = ({
  isAssignContractorsOpen,
  closeAssignContractors,
  refreshLinkedContractors,
  selectedMCCustomerId,
}: Props) => {
  const container = document.getElementById('root')

  return (
    <Modal
      container={container}
      open={isAssignContractorsOpen}
      onClose={closeAssignContractors}
      aria-labelledby="assign-contractor-modal-title"
      aria-describedby="assign-contractor-modal-description"
      css={tw`flex flex-row w-full h-full`}
    >
      <Fragment>
        <div
          data-testid="link-customer-assign-contractors-modal"
          css={tw`w-[1120px] h-full bg-white flex flex-col`}
        >
          <ModalHeader
            className={tw`border-b-0`}
            title="Link contractor(s)"
            onClose={closeAssignContractors}
            closeButtonDataTestId="link-customer-assign-contractors-modal-close-btn"
          />
          <AssignContractorsTable
            refreshLinkedContractors={refreshLinkedContractors}
            selectedMCCustomerId={selectedMCCustomerId}
          />
        </div>
        <div id="team-details" css={tw`flex m-6 w-[440px] pointer-events-none`} />
      </Fragment>
    </Modal>
  )
}
